import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { MIRRORS_LIST_PERMISSIONS } from '@modules/mirrors-list/constants';
import {
  MIRRORS_LIST_CREATE_JS_ROUTE_NAME,
  MIRRORS_LIST_CREATE_NO_JS_ROUTE_NAME,
} from '@modules/mirrors-list/submodules/create/constants';
import {
  MIRRORS_LIST_CREATE_FILE_JS_ROUTE_NAME,
  MIRRORS_LIST_CREATE_FILE_NO_JS_ROUTE_NAME,
  TRANSLATION_GROUP_MIRRORS_CREATE_FILE,
} from '@modules/mirrors-list/submodules/create/submodules/file/constants';
import getTranslationKeys from '@modules/mirrors-list/submodules/create/submodules/file/translations';

export class MirrorAddFileModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(MIRRORS_LIST_CREATE_JS_ROUTE_NAME, {
      name: MIRRORS_LIST_CREATE_FILE_JS_ROUTE_NAME,
      path: 'file',
      permission: MIRRORS_LIST_PERMISSIONS.CREATE,
      component: () => import('@modules/mirrors-list/submodules/create/submodules/file/pages/MirrorAddFilePage/MirrorAddFilePage.vue'),
    });

    router.addChildRoute(MIRRORS_LIST_CREATE_NO_JS_ROUTE_NAME, {
      name: MIRRORS_LIST_CREATE_FILE_NO_JS_ROUTE_NAME,
      path: 'file',
      permission: MIRRORS_LIST_PERMISSIONS.CREATE,
      component: () => import('@modules/mirrors-list/submodules/create/submodules/file/pages/MirrorAddFilePage/MirrorAddFilePage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_MIRRORS_CREATE_FILE, getTranslationKeys);
  }
}
